export function getUserInfo() {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || '{}')
  } catch {
    return {}
  }
}

export function setUserInfo(userInfo) {
  localStorage.setItem('userInfo', JSON.stringify(userInfo))
}

export function getUserId() {
  const userInfo = getUserInfo()
  // 兼容 userId/userid
const userId = userInfo.userId || userInfo.userid

  return parseInt(userId, 10)
}

export function getUsername() {
  const userInfo = getUserInfo()
  return userInfo.username || ''
}